import { StyleSheet } from 'aphrodite';

export default StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 86,
    paddingLeft: 20,
    paddingRight: 20,
    overflow: 'hidden',
    backgroundColor: '#385DAE',
  },

  title: {
    flex: '1 1 0',
    flexDirection: 'row',
    alignItems: 'center',
  },

  titleLogo: {
    height: 28,
  },

  hyLogo: {
    height: 56,
  },

  titleSplit: {
    width: 1,
    height: 28,
    marginLeft: 20,
    marginRight: 20,
    backgroundColor: '#fff',
    opacity: 0.3,
  },

  titleText: {
    flex: 'auto',
    display: 'block',
    color: '#fff',
    fontSize: 22,
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  parts: {
    flex: 'none',
    flexDirection: 'row',
    fontSize: 18,
    color: '#fff',
    whiteSpace: 'nowrap',
    textAlign: 'center',
    maxWidth: '400px',
    overflowX: 'auto',
    height: '200%', // 隐藏滚动条
    alignItems: 'center',
  },

  part: {
    marginLeft: 20,
    marginRight: 20,
    opacity: 0.5,
    cursor: 'pointer',
    userSelect: 'none',
  },

  selectedPart: {
    position: 'relative',
    opacity: 1,
    '::after': {
      content: '""',
      position: 'absolute',
      left: 'calc(50% - 10px)',
      bottom: -8,
      width: 20,
      height: 4,
      borderRadius: '2px',
      backgroundColor: '#fff',
    },
  },

  normalButtons: {
    flex: '1 1 0',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },

  button: {
    marginLeft: 10,
    backgroundColor: '#fff',
    color: '#333',
    ':hover': {
      backgroundColor: '#EDF3FF',
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/listen/header/styles.js